import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { Clear } from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { axiosPrivate } from "../../../axios/axios";
import { masterAPI } from "../dataConfig";
import { toast } from "react-toastify";
import ErrorProps from "../../../Component/Errorprops";

const CreateAssetCategory = ({ mode, handleCloseClick,editData }) => {
  const [parentId, setParentId] = useState([]);
  const [loading,setLoading]=useState(false)

  useEffect(() => {
   getData()
  }, []);

  const getData=async()=>{
    setLoading(true)
    const link = masterAPI["assetCategory"].link;
   await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        setLoading(false)
        setParentId(res.data.result);
      })
      .catch((e) => {
        setLoading(false)
        setParentId([])
        console.log(e, "createACgetAll");
      });
  }

  const initialValue = {
    code: mode==="Edit"?editData.code: "",
    assetCategoryName: mode==="Edit"?editData.assetCategoryName: "",
    // parentCategoryId:mode==="Edit"?editData.parentCategoryId: null,
  };
 const validationSchema = Yup.object().shape({

  code:Yup.string().required("Asset Category Code is required"),
  assetCategoryName:Yup.string().required("Asset Category Name is required"),
 });
  const onSubmit = async(value) => {
    console.log(value);
    setLoading(true)
    const createLink = masterAPI["assetCategory"].create;
    const updateLink=masterAPI["assetCategory"].update
    if(mode==="Create"){
     await axiosPrivate.post(`${createLink}`,value).then(res=>{
        console.log(res.data)
        setLoading(false)
        handleCloseClick()
      }).catch(e=>{
        setLoading(false)
        console.log(e,"createAC")
        // toast.error(e.response.data.failureMessage)
      })
    }else{
      const updateAC={
        id:editData.id,
        ...value
      }
     await axiosPrivate.put(`${updateLink}`,updateAC).then(res=>{
        console.log(res.data)
        setLoading(false)
        handleCloseClick()
      }).catch(e=>{
        setLoading(false)
        console.log(e,"updateAC")
          // if(e.response.data.FailureMessage)
          // {
          //   toast.error("Asset Category Code is already exists")
          // }
      })
    }
   
  };

  const handleCancel = () => {
    handleCloseClick();
  };

  return (
    <Box sx={{ p: color.masterPageDialogPadding}}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
          }}
        >
          {mode === "Edit"?editData.code+"-"+editData.assetCategoryName:"New Asset Category"}
        </Typography>
        <IconButton onClick={handleCancel}>
          <Clear />
        </IconButton>
      </Box>
      <Divider sx={{border:"1px solid rgb(0 0 0 / 17%)",mb:"15px"}} />
      <Formik initialValues={initialValue} validationSchema={validationSchema} onSubmit={onSubmit}>
      {({ handleChange, setFieldValue, values , resetForm }) => (
        <Form>
          <Grid container spacing={"1rem"}>
          <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Asset Category Code
                </Typography>
              <Field
                as={TextField}
                size={"small"}
                type="text"
                name="code"
                placeholder="Enter Asset Category Code"
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
               <ErrorMessage name="code">
                {(error) => <ErrorProps>{error}</ErrorProps>}
              </ErrorMessage>
            </Grid>
            <Grid item xs={12} md={6}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Asset Category Name
                </Typography>
              <Field
                as={TextField}
                size={"small"}
                type="text"
                name="assetCategoryName"
                placeholder="Enter Asset Category Name"
                fullWidth
                sx={{
                  ".MuiInputBase-input": {
                    // letterSpacing: "0.2rem",

                    "&::placeholder": {
                      // color: "green",
                      opacity: 1,
                      color: color.placeholderColor,
                      fontSize: "13px",
                    },
                  },
                }}
              />
                       <ErrorMessage name="assetCategoryName">
                {(error) => <ErrorProps>{error}</ErrorProps>}
              </ErrorMessage>
            </Grid>
            
            {/* <Grid item xs={12} md={12}>
            <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                 Parent Category
                </Typography>
                
              <Field
                as={Select}
                // label={"Select"}
                size={"small"}
                type="text"
                name="parentCategoryId"
                placeholder="Enter Asset Category Name"
                fullWidth
                displayEmpty
                MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
               renderValue={values.parentCategoryId !== null ? undefined : () =><Typography sx={{  color: color.placeholderColor,
                fontSize: "13px",}} >Select</Typography> }
              >
               
                {parentId.map((id, i) => (
                  <MenuItem value={id.id} disabled={editData.id===id.id&&mode==="Edit"}>
                    {id.code+" - "+id.assetCategoryName}
                    </MenuItem>
                ))}
              </Field>
            </Grid> */}
            <Grid container item xs={12} justifyContent={"flex-end"} gap="1rem">
              <Button
                onClick={handleCancel}
                variant="contained"
                sx={{
                  backgroundColor: color.TableCancelButton,
                  textTransform: "none",
                  color: color.CancelTextColor,
                  ":hover":{
                    backgroundColor: color.TableCancelButton,
                    textTransform: "none",
                    color: color.CancelTextColor,
                  }
                }}
              >
                Cancel
              </Button>
              <Button
                type={"submit"}
                variant="contained"
                disabled={loading}
                sx={{
                      
                  textTransform: "none",
                  backgroundColor: loading ? "default" : color.TableButtonColor,
                  "&:hover": {
                    backgroundColor: loading
                      ? "default"
                      : color.buttonDisable,
                  },
                }}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
      </Formik>
    </Box>
  );
};

export default CreateAssetCategory;
